import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import SeoContent from "./components/SeoContent";
import ArticleGallery from "./components/ArticleGallery";
import TrustSection from "./components/TrustSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://yoybuy.asia";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl + "/",
      "name": "YoyBuy Asia",
      "description": "YoyBuy Asia — профессиональная платформа Yoybuy Sheet для организации заказов из Китая через электронные таблицы. Экономьте время с автоматизированной spreadsheet-системой для оптовых и розничных закупок.",
      "inLanguage": "ru",
      "publisher": { "@id": `${siteUrl}/#organization` }
    },
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      "name": "YoyBuy Asia",
      "url": siteUrl + "/",
      "description": "Профессиональная платформа Yoybuy Sheet для заказов из Китая через spreadsheet-систему.",
      "sameAs": [
        "https://kaspreadsheet.com"
      ]
    }
  ]
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <Hero />
      <article>
        <CategoryGrid />
      </article>
      <article>
        <SeoContent />
      </article>
      <article>
        <ArticleGallery />
      </article>
      <article>
        <TrustSection />
      </article>
      <article>
        <CtaSection />
      </article>
      <Footer />
    </main>
  );
}